const ko = {
    "sc_title": "보안 센터",
    "sc_subtitle": "GaiaShield 통합 보안 계층",
    "sc_tab_status": "🛡️ 보호 상태",
    "sc_tab_events": "📋 보안 로그",
    "sc_tab_node": "⚙️ 노드 보안",
    "sc_loading": "보안 데이터 로드 중...",
    "sc_status_secured": "시스템 상태: 계정이 보호됨",
    "sc_status_warning": "시스템 상태: 경고 활성화됨",
    "sc_desc_secured": "활성 상태의 심각한 보안 경고가 없습니다. GaiaShield가 계정을 적극적으로 모니터링하고 있습니다.",
    "sc_desc_warning": "주의: 주의가 필요한 활성 보안 이벤트가 있습니다.",
    "sc_account_protection": "계정 보호",
    "sc_message_protection": "메시지 보호",
    "sc_audits": "보안 감사",
    "sc_active": "활성화됨",
    "sc_failed_logins": "로그인 실패",
    "sc_tamper_checks": "변조 확인",
    "sc_blocked_replays": "차단된 리플레이",
    "sc_last_check": "마지막 확인",
    "sc_just_now": "방금 전",
    "sc_open_warnings": "해결되지 않은 경고",
    "sc_btn_acknowledge": "확인",
    "sc_filter_severity": "심각도",
    "sc_filter_category": "카테고리",
    "sc_filter_hide_ack": "확인된 항목 숨기기",
    "sc_btn_export": "내보내기",
    "sc_col_details": "상세 정보",
    "sc_col_time": "시간",
    "sc_col_status": "상태",
    "sc_col_action": "작업",
    "sc_no_events": "보안 이벤트가 없습니다.",
    "sc_node_title": "노드 운영자 보안 콘ソール",
    "sc_system_health": "시스템 상태",
    "sc_last_audit": "마지막 감사",
    "sc_packed_logs": "패키징된 로그",
    "sc_unconfirmed_events": "미확인 이벤트",
    "sc_operator_action": "운영자 조치 필요",
    "sc_all_ok": "모두 정상",
    "sc_critical_events": "심각한 시스템 이벤트",
    "ac_title": "거버넌스 및 신고 센터",
    "ac_subtitle": "GaiaCom 거버넌스 및 신고 합의",
    "ac_tab_my_reports": "내 신고 내역",
    "ac_tab_queue": "검토 대기열",
    "ac_tab_operator": "노드 운영자",
    "ac_tab_transparency": "연합 및 투명성",
    "ac_loading": "데이터 로드 중...",
    "ac_reported_cases": "신고된 케이스",
    "ac_no_reports": "아직 신고한 내역이 없습니다.",
    "ac_case_details": "케이스 상세 정보",
    "ac_appeal_submit": "이의 제기 제출",
    "ac_appeal_status": "이의 제기 상태",
    "ac_appeal_reason": "이의 제기 이유",
    "ac_appeal_statement": "의견서",
    "ac_btn_appeal": "이의 제기 보내기",
    "ac_trusted_reviewer_queue": "신뢰할 수 있는 검토자 대기열",
    "ac_case_review": "케이스 검토",
    "ac_review_category": "권장 카테고리",
    "ac_review_severity": "권장 심각도",
    "ac_review_action": "권장 조치",
    "ac_review_reason": "검토자 사유",
    "ac_btn_submit_review": "검토 결과 제출",
    "ac_node_operator_dashboard": "노드 운영자 대시보드",
    "ac_apply_action": "조치 적용 (재정의)",
    "ac_target_type": "대상 유형",
    "ac_target_id": "대상 ID (GaiaID 또는 채널 ID)",
    "ac_suspend": "정지 활성화됨",
    "ac_reason": "공식 사유",
    "ac_btn_apply": "조치 시행",
    "ac_transparency_title": "합의 및 투명성 기록부",
    "ac_transparency_desc": "조정된 모든 채널 및 신원의 공개 가능한 스냅샷 증명.",
    "ac_btn_snapshot": "투명성 스냅샷 만들기",
    "search_placeholder": "제목, 보낸 사람, 본문으로 메일 검색...",
    "abuse_center_title": "신고 센터",
    "abbrechen": "취소",
    "active_identities": "활성 ID",
    "active_identity": "활성 신원",
    "add_btn": "추가하다",
    "add_contact_title": "연락처 추가",
    "admin": "관리자",
    "adressbuch": "예배 규칙서",
    "aktiviert": "활성화됨",
    "an": "에게",
    "anonymous_sender": "익명의 발신자",
    "antworten": "답변",
    "attachment_gaia_hint": "GaiaCOM 첨부 파일은 종단 간 암호화된 상태로 유지됩니다.",
    "attachment_smtp_hint": "레거시 SMTP는 실행 가능/스크립트와 유사한 첨부 파일을 차단하고 이메일을 안전하지 않은 것으로 저장합니다.",
    "attachments": "첨부파일",
    "auffaellig": "눈에 띄는",
    "auth_beta_notice": "베타 테스트 단계: GaiaCOM은 적극적으로 테스트되고 있습니다. 오류가 발생할 수 있습니다. 중요한 씨앗을 확보하고 기밀 작업 흐름을 주의 깊게 검토하세요.",
    "auth_btn_login": "ID 로드 및 로그인",
    "auth_btn_register": "암호화폐 등록 및 생성",
    "auth_copied": "복사됨",
    "auth_copy_seed": "시드 복사",
    "auth_generate_seed": "시드 생성",
    "auth_headline": "GaiaCOM은 인류를 위해 구축된 최초의 양자 안전 이메일 프로토콜 및 통신 시스템입니다.",
    "auth_kicker": "포스트퀀텀 보안통신",
    "auth_mnemonic": "니모닉 문구",
    "auth_mnemonic_placeholder": "공백으로 구분된 12단어...",
    "auth_password": "비밀번호",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "개인 키는 장치 외부로 유출되지 않습니다. 의도된 수신자만 콘텐츠를 해독할 수 있습니다.",
    "auth_proof_gaiadata_desc": "영지식: 귀하는 귀하의 데이터를 계속 통제할 수 있습니다. 메타데이터는 최소화되며 일반 텍스트 프로필로 사용되지 않습니다.",
    "auth_proof_gaiadrop_desc": "외부인은 계정 없이 귀하의 GaiaID에 기밀 문자 메시지를 보낼 수 있습니다.",
    "auth_proof_gaiaproof_desc": "배달 및 무결성 증거는 암호문, 보낸 사람 및 타임스탬프가 변조되지 않았음을 보여줍니다.",
    "auth_proof_gaiavault_desc": "개인 메모, 복구 메모 및 보안 기록은 로컬로 암호화된 상태로 유지됩니다.",
    "auth_proof_hybrid_desc": "Quantum Shield: ML-KEM 및 X25519를 사용한 하이브리드 암호화는 오늘날의 공격과 나중에 암호 해독 저장 위험으로부터 보호합니다.",
    "auth_secure_mail": "보안 양자 페더레이션 메일",
    "auth_subline": "GaiaCOM은 이메일, 채팅, 위기관리실, GaiaDrop 및 로컬 보안 파일을 위한 양자 보안 통신 시스템입니다. 개인 키는 장치에 유지되고 콘텐츠는 종단 간 암호화되며 일반 텍스트 없이 증거를 내보낼 수 있습니다.",
    "auth_success_btn": "지금 로그인하세요",
    "auth_success_text": "귀하의 GaiaCOM 계정이 생성되었습니다. 키는 시드에서 로컬로 파생되었으며 서버에 저장되지 않았습니다.",
    "auth_success_title": "등록 성공",
    "auth_tab_drop": "가이아드롭",
    "auth_tab_login": "로그인/계정",
    "auth_toggle_login": "계정이 이미 존재합니다.",
    "auth_toggle_register": "새 계정 만들기",
    "auth_usecase_text": "변호사, 회사, 당국, 언론인, 내부 고발자 및 개인 보안 사건에 적합합니다.",
    "auth_usecase_title": "민감한 커뮤니케이션을 위해 제작됨",
    "auth_username": "사용자 이름",
    "auth_username_placeholder": "이름을 입력하세요...",
    "auth_value_chat": "E2E 채팅",
    "auth_value_drop": "보안 드롭",
    "auth_value_mail": "보안 메일",
    "auth_value_rooms": "가이아룸스",
    "bestaetigen": "확인하다",
    "bestaetigt": "확인됨",
    "bio_status": "약력/현황",
    "biography": "전기",
    "change_password_desc": "서버 측 로그인 비밀번호를 변경합니다. 로컬 복구 문구는 볼트/잠금 해제 비밀번호로 별도로 보호됩니다.",
    "change_password_menu_desc": "GaiaCOM 로그인 비밀번호를 업데이트하세요.",
    "change_password_title": "비밀번호 변경",
    "channel_id": "채널 ID",
    "channel_name_label": "채널 이름",
    "chat_deleted_hidden": "채팅이 삭제되고 숨겨졌습니다.",
    "chat_input_placeholder": "보안 메시지를 입력하세요...",
    "chat_start_hint": "대화를 시작하세요! 모든 채팅 메시지는 양자 보안 E2E 암호화됩니다.",
    "choose_avatar": "아바타 선택",
    "ciphertext_hash": "암호문 해시",
    "clear_chat": "빈 채팅",
    "clear_for_everyone": "모두를 위해 비워두세요",
    "clear_for_me": "나만을 위해 비워두세요",
    "click_to_write_mail": "이메일을 작성하려면 클릭하세요.",
    "click_top_right": "오른쪽 상단을 클릭하세요.",
    "close": "닫다",
    "code_kopieren": "코드 복사",
    "code_kopieren_success": "코드 복사됨",
    "confirm_clear_channel_desc": "로컬 보기에서 이 채널을 삭제하시겠습니까?",
    "confirm_clear_channel_title": "빈 채널",
    "confirm_clear_chat": "이 채팅을 비우시겠습니까?",
    "confirm_clear_chat_desc": "이 채팅을 비우시겠습니까?",
    "confirm_clear_chat_title": "빈 채팅",
    "confirm_clear_everyone": "두 파트너 모두의 채팅을 비우시겠습니까? (OK = 모두에게, 취소 = 나만을 위해)",
    "confirm_delete_everyone": "두 파트너 모두의 메시지를 삭제하시겠습니까? (OK = 모두에게, 취소 = 나만을 위해)",
    "confirm_delete_msg": "이 메시지를 삭제하시겠습니까?",
    "confirm_delete_msg_desc": "이 채팅 메시지를 삭제하시겠습니까?",
    "confirm_delete_msg_title": "메시지 삭제",
    "confirm_new_password": "새 비밀번호 확인",
    "copy": "복사",
    "create_btn": "만들다",
    "create_channel_title": "채널 만들기",
    "create_group_is_crisis": "위기지역으로 표시",
    "create_group_title": "새 그룹 만들기",
    "crypto_lock_desc": "GaiaCOM이 메모리에서 로컬 암호화 키를 제거하는 시기를 제어합니다.",
    "crypto_lock_menu_desc": "다시 로드 및 비활성 타이머를 제어합니다.",
    "crypto_lock_title": "암호화 잠금",
    "crypto_session_duration": "다시 로드한 후 잠금 해제됨",
    "crypto_session_duration_desc": "선택한 기간 동안만 이 브라우저 탭에서 암호화 세션을 열어 둡니다.",
    "cryptographic_fingerprint": "암호화 지문",
    "current_password": "현재 비밀번호",
    "data_minimization": "데이터 최소화",
    "decrypt_failed": "해독 불가",
    "delete": "삭제",
    "delete_account_button": "취소할 수 없는 계정 삭제",
    "delete_account_confirm_label": "확인하려면 DELETE를 입력하세요.",
    "delete_account_confirmation_error": "비밀번호와 DELETE 확인이 필요합니다.",
    "delete_account_desc": "이 모드는 귀하의 계정, 신원, 장치 세션, GaiaDrop 데이터, 업로드 메타데이터 및 서버 측 속성 메시지를 영구적으로 파괴합니다.",
    "delete_account_done_desc": "할당 가능한 모든 GaiaCOM 데이터가 삭제되었습니다.",
    "delete_account_done_title": "계정이 삭제되었습니다",
    "delete_account_menu_desc": "계정 및 관련 데이터를 파기합니다.",
    "delete_account_not_authenticated": "활성 계정이 없습니다.",
    "delete_account_title": "계정 삭제",
    "delete_for_everyone": "모든 사람에 대해 삭제",
    "delete_for_me": "나만을 위해 삭제",
    "device_current": "이 장치",
    "device_last_seen": "마지막",
    "device_logout": "로그아웃",
    "device_sessions_desc": "활성 세션을 확인하고 더 이상 신뢰하지 않는 장치의 등록을 취소하세요.",
    "device_sessions_empty": "기기를 찾을 수 없습니다.",
    "device_sessions_menu_desc": "활성 세션을 관리하고 종료합니다.",
    "device_sessions_title": "등록된 기기",
    "device_since": "부터",
    "display_name": "표시 이름",
    "drop_address_copied": "GaiaDrop 주소가 복사되었습니다.",
    "drop_btn_decrypting": "받은편지함을 해독하는 중입니다...",
    "drop_btn_load": "GaiaDrop 받은 편지함 로드",
    "drop_delete_desc": "정말로 이 드롭을 영구적으로 삭제하시겠습니까?",
    "drop_delete_title": "GaiaDrop 삭제",
    "drop_desc": "외부 통지, 책임 있는 공개 및 기밀 보고를 위한 텍스트 전용 영지식 드롭 채널입니다. 외부 당사자는 귀하의 GaiaID를 사용하여 계정 없이도 메시지를 보낼 수 있습니다.",
    "drop_empty": "아직 GaiaDrop 메시지가 로드되지 않았습니다.",
    "drop_id": "삭제 ID:",
    "drop_own_address": "귀하의 GaiaDrop 주소",
    "drop_proof": "낙하 방지",
    "drop_title": "GaiaDrop 보안 받은 편지함",
    "dunkler_modus": "다크 모드",
    "e2e_chat_room_open": "E2E 채팅방 열기",
    "edit_profile": "프로필 수정",
    "edit_profile_desc": "표시 이름, 약력, 아바타를 맞춤설정하세요.",
    "einladungscode": "초대코드",
    "enter_fingerprint_chars_confirm": "확인을 위해 요청된 지문 문자를 입력하세요.",
    "envelope_hash": "봉투 해시",
    "erasability": "지울 수 있음",
    "erfolg": "성공",
    "exclude_plaintext": "일반 텍스트 없이 내보내기",
    "export_disclosure": "보안 케이스 수출",
    "export_package_desc": "이 공개가 의도적으로 의도된 경우에만 일반 텍스트를 포함하십시오.",
    "export_package_title": "보안 패키지 내보내기",
    "fehler": "실수",
    "gaiacom_reader": "GaiaCOM 리더",
    "gaiadrop_inbox_title": "GaiaDrop 받은 편지함",
    "gaiavault": "가이아볼트",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM은 메타데이터를 최소화하고 개인 키를 로컬에 유지하며 콘텐츠를 엔드 투 엔드로 암호화하고 완전한 계정 삭제를 가능하게 합니다.",
    "gdpr_home_title": "GDPR 100% 준수",
    "gdpr_reason_delete": "계정 삭제는 계정, ID, 로컬 세션 및 서버 측 할당 가능 데이터를 제거합니다.",
    "gdpr_reason_e2ee": "비공개 콘텐츠는 의도된 수신자만 해독할 수 있습니다.",
    "gdpr_reason_minimal": "메타데이터는 라우팅, 전달 및 보안 자격 증명에만 사용됩니다.",
    "gdpr_reason_zero_knowledge": "개인 키와 복구 데이터는 사용자 제어 하에 로컬로 유지됩니다.",
    "gesendet": "전송된",
    "gesperrt_verdaechtig": "금지됨 / 의심됨",
    "group_delete_desc": "정말로 이 그룹을 영구적으로 삭제하시겠습니까? 이 그룹의 모든 채널과 메시지가 삭제됩니다.",
    "group_delete_title": "그룹 삭제",
    "group_description": "설명",
    "group_icon_label": "그룹 아이콘 / 아바타",
    "group_name": "그룹 이름",
    "group_settings_avatar": "화신",
    "group_settings_desc": "설명",
    "group_settings_is_crisis": "위기지역으로 표시",
    "group_settings_name": "그룹 이름",
    "group_settings_title": "그룹 설정",
    "groups_empty_desc": "프로젝트, 위기 상황, 팀 커뮤니케이션을 위한 안전한 작업 공간을 만드세요.",
    "groups_empty_title": "아직 그룹 채팅이 없습니다.",
    "gruppe_beitreten": "가입된 그룹",
    "gruppe_erstellen": "+ 그룹 만들기",
    "gruppe_verlassen": "그룹 탈퇴",
    "gruppen_chats": "그룹 채팅",
    "heller_modus": "밝은 모드",
    "how_to_receive_drops": "상품을 받으려면 어떻게 해야 하나요?",
    "identitaets_assistent": "신원 도우미",
    "inactivity_lock_duration": "비활성 시 잠금",
    "inactivity_lock_duration_desc": "입력이 없는 기간이 지나면 GaiaCOM은 자동으로 암호화되어 잠깁니다.",
    "inactivity_lock_notice": "GaiaCOM은 활동이 없어 암호화되어 차단되었습니다.",
    "include_plaintext": "일반 텍스트 포함",
    "invite_code_label": "초대코드",
    "join_group_title": "그룹에 가입",
    "kanaele": "채널",
    "kanal_erstellen": "+ 채널",
    "kein_chat_ausgewaehlt": "선택된 채팅 없음",
    "kein_kanal_ausgewaehlt": "선택된 채널이 없습니다",
    "keine_gruppe_ausgewaehlt": "선택한 그룹이 없습니다.",
    "keine_mails": "사용할 수 있는 이메일이 없습니다.",
    "key_change_warn_desc": "이 연락처의 공개 키가 변경되었습니다. 신뢰하기 전에 지문을 확인하세요.",
    "key_change_warn_title": "암호화 경고",
    "key_change_warning_changed": "변경되었습니다. 이는 중간자 공격의 징후일 수 있습니다!",
    "key_change_warning_msg": "연락처의 ID 키",
    "key_transparency": "주요 투명성",
    "kopiert": "복사됨",
    "kryptographische_schluessel": "암호화 키",
    "kryptographische_schluessel_desc": "개인 키와 백업 시드 문구를 표시합니다.",
    "laden": "짐...",
    "leeren": "비어 있는",
    "loading": "짐...",
    "local_key_vault": "로컬 키 자격 증명 모음",
    "local_keys_label": "로컬 키",
    "lock_on_reload": "다시 로드한 후 항상 잠금",
    "logout": "로그아웃",
    "mail_compose": "이메일 쓰기",
    "mein_profil": "내 프로필",
    "melden": "보고서",
    "menu": "메뉴",
    "message": "소식",
    "message_id": "메시지 ID",
    "message_pin": "핀",
    "message_pinned_title": "고정된 메시지",
    "message_react": "반응하다",
    "message_reply": "답변",
    "message_replying_to": "에 대한 답변",
    "message_save": "구하다",
    "message_saved": "저장됨",
    "message_to_channel": "메시지 보내기",
    "message_unpin": "해결하다",
    "message_unsave": "저장하지 않음",
    "mitglied": "회원",
    "mitglieder": "회원",
    "ml_kem": "ML-KEM",
    "neue_mail": "새 이메일",
    "never_auto_lock": "자동으로 사용 안함",
    "new_fingerprint": "새로운 지문",
    "new_identity": "새로운 정체성",
    "new_password": "새 비밀번호",
    "no_description": "설명 없음",
    "no_key_history": "기록된 주요 기록이 없습니다.",
    "no_specification": "지정되지 않음",
    "old_fingerprint": "오래된 지문",
    "open_privacy_imprint": "개방형 인쇄물 및 데이터 보호",
    "post_quantum_e2e": "포스트퀀텀 E2E",
    "posteingang": "받은편지함",
    "powered_by": "제공:",
    "privacy_imprint_menu_desc": "GDPR, 데이터 보호 및 법적 고지를 표시합니다.",
    "privacy_imprint_profile_desc": "GaiaCOM은 데이터 최소화, 종단 간 암호화 및 로컬 키 제어 원칙에 따라 통신 콘텐츠를 처리합니다.",
    "privacy_imprint_title": "데이터 보호 및 법적 고지",
    "profil": "윤곽",
    "profile_details": "프로필 세부정보",
    "profile_settings_hint": "프로필 설정이 오른쪽 패널에 표시됩니다.",
    "profile_unlock_desc": "보안상의 이유로 개인 암호화 키를 보려면 비밀번호를 다시 입력해야 합니다.",
    "proof_hash": "증명 해시:",
    "public_drop_desc": "GaiaCOM 계정 없이 외부 텍스트 정보에 대한 Secure Drop.",
    "public_drop_message": "소식",
    "public_drop_message_placeholder": "기밀 문자를 입력하세요...",
    "public_drop_send": "GaiaDrop 보내기",
    "public_drop_sender": "보낸 사람 메모 선택 사항",
    "public_drop_sender_placeholder": "이름, 파일 번호 또는 익명",
    "public_drop_target": "대상 GaiaID",
    "quanten_chat": "퀀텀채팅",
    "quantum_secure_exchange": "양자 보안 교환을 통해...",
    "quantum_secure_net": "GaiaCOM 양자 보안 네트워크(Ed25519 및 ML-KEM)",
    "quantum_shield_desc": "GaiaCOM 네트워크는 미래 양자 컴퓨터의 공격으로부터 보호되는 다층 하이브리드 암호화 프로토콜을 통해 귀하의 개인 정보를 보호합니다.",
    "quantum_shield_l1_desc": "FIPS 203 표준을 사용하여 대칭 공유 키를 캡슐화합니다. 양자 컴퓨터에 의한 수동 기록 및 나중에 암호 해독(\\",
    "quantum_shield_l1_title": "1. 양자후방호(ML-KEM-1024)",
    "quantum_shield_l2_desc": "하이브리드 절차에서 추가 보안 계층 ​​역할을 하는 매우 빠른 클래식 Diffie-Hellman 키 교환 절차입니다.",
    "quantum_shield_l2_title": "2. 타원곡선 암호화(X25519)",
    "quantum_shield_l3_desc": "모든 메시지와 모든 페더레이션 봉투는 보낸 사람의 진위 여부를 명확하게 확인하기 위해 암호화 방식으로 서명됩니다.",
    "quantum_shield_l3_title": "3. 디지털 서명(Ed25519)",
    "quantum_shield_l4_desc": "메시지 콘텐츠를 대칭적으로 암호화하고 발신자, 수신자 및 메타데이터를 인증된 추가 데이터(AAD)에 긴밀하게 바인딩하여 재생 공격을 방지합니다.",
    "quantum_shield_l4_title": "4. AAD 인증(AES-256-GCM)",
    "quantum_shield_status": "퀀텀 쉴드 상태",
    "receive_drops_step1": "GaiaID를 외부 소스와 공유하세요(예: 위의 복사 버튼 사용).",
    "receive_drops_step2": "GaiaCOM 인스턴스의 로그인 페이지를 호출하고 탭으로 전환합니다.",
    "receive_drops_step3": "암호화된 메시지를 귀하의 주소로 보내세요.",
    "receiver_gaia": "GaiaCOM 수신기",
    "receiver_smtp": "SMTP 수신자",
    "records_stored": "저장된 기록",
    "refresh": "업데이트",
    "report_abuse_desc": "이 메시지를 신고하고 남용에 대한 암호화 증거를 서버에 제출하시겠습니까?",
    "report_abuse_title": "악용사례 신고",
    "reputation_status": "평판 상태",
    "room_chat_start_hint": "대화를 시작하세요! 이 그룹 채널의 모든 메시지는 분산형 양자 안전 E2E 암호화됩니다.",
    "room_policy_audit": "감사 추적 및 키 순환이 활성화되었습니다.",
    "room_policy_crisis": "위기의 방",
    "room_policy_e2ee": "지식이 없는 공간. E2EE 양자 안전.",
    "room_policy_title": "객실 지침",
    "room_policy_zero_knowledge": "정책",
    "room_security_note_desc": "모든 주요 변경 사항은 키 투명성을 통해 검증됩니다. 개인 백업 로그에는 GaiaVault를 사용하세요.",
    "room_security_note_title": "고정된 보안 메모",
    "save_profile": "프로필 저장",
    "schluessel_entsperrt": "🔑 열쇠를 다시 잠그세요",
    "search_gaia_label": "가이아 주소 찾기",
    "security_warning_title": "보안 경고",
    "select_channel_chat": "채팅하려면 왼쪽 사이드바에서 채널을 선택하세요.",
    "select_contact_chat": "양자 안전 E2E 채팅을 시작하려면 왼쪽 패널에서 연락처를 선택하세요.",
    "select_mail_read": "목록에서 이메일을 선택하여 양자 안전 콘텐츠를 읽거나 새 메시지를 작성하세요.",
    "senden": "보내다",
    "sender_signature": "발신자 서명",
    "server_log": "서버 로그:",
    "server_received": "서버 수신됨",
    "session_lock": "세션 잠금",
    "setup_address_keys": "주소 및 키 세트 생성",
    "setup_profile": "프로필에서 설정",
    "smtp_inbox_title": "SMTP 수신",
    "smtp_legacy_badge": "기존 SMTP/안전하지 않음",
    "smtp_mode_option": "레거시 SMTP 브리지",
    "smtp_security_warning": "이 이메일은 암호화되지 않은 일반적인 SMTP 프로토콜을 통해 전송되었습니다. 활성화된 종단 간 암호화가 없습니다.",
    "smtp_security_warning_desc": "이 메시지는 GaiaCom 보안실에서 나갑니다. SMTP 전달은 GaiaCom 기본 엔드투엔드 보장, TrustMesh 보장 및 게이트웨이의 Godmode 보장을 제공하지 않습니다.",
    "spam_verdacht": "스팸/의심",
    "spam_warning_desc": "이 메시지에는 의심스러운 평판 신호가 있습니다.",
    "spam_warning_title": "스팸 경고",
    "speichern": "구하다",
    "sperren": "잠금",
    "standard_group_status": "표준 그룹 채팅(E2EE 암호화)",
    "status": "상태",
    "subject": "에 관하여",
    "suchen": "새 Gaia 주소 찾기...",
    "tage": "날",
    "time_unknown": "시간을 알 수 없음",
    "transmission_mode": "전송 모드",
    "trust_age": "신뢰 연령",
    "trust_passport_title": "트러스트 여권",
    "unbestaetigt": "확인되지 않음",
    "unknown_sender": "알려지지 않은",
    "unlock_btn": "터놓다",
    "unlock_btn_profile": "터놓다",
    "unlock_desc": "개인 키 파일은 암호화되어 저장됩니다. 암호화 키를 메모리에만 로드하려면 비밀번호를 입력하세요.",
    "unlock_logout": "로그아웃하고 로컬 키 닫기",
    "unlock_title": "신원 잠금 해제",
    "untrusted": "신뢰할 수 없음",
    "update_password": "비밀번호 업데이트",
    "upload_avatar_btn": "이미지 업로드(삭제됨)",
    "vault_btn_encrypt": "기록 암호화",
    "vault_btn_lock": "금고를 잠그세요",
    "vault_btn_unlock": "금고 잠금 해제",
    "vault_copied_success": "클립보드에 복사됨",
    "vault_decrypted_content": "해독된 콘텐츠",
    "vault_desc": "복구 백업, ID 메모, 서버 액세스, 비상 연락처, 법적 메모, 보안 이벤트 및 개인 로그를 위한 로컬 암호화 저장소입니다.",
    "vault_empty": "아직 저장된 보안 기록이 없습니다.",
    "vault_locked_pane_notice": "금고는 잠겨 있습니다. 오른쪽에서 잠금을 해제해 주세요.",
    "vault_new_record": "새로운 보안 기록",
    "vault_pwd_placeholder": "Vault 비밀번호를 입력하세요...",
    "vault_record_body": "녹음 내용",
    "vault_record_body_placeholder": "암호화된 기록 내용을 입력하세요...",
    "vault_record_category": "범주",
    "vault_record_title": "음반 제목",
    "vault_record_title_placeholder": "보안 기록의 제목",
    "vault_title": "GaiaVault 보안 기록",
    "verify_new_fingerprint_hint": "키를 수락하기 전에 새 지문을 확인하세요.",
    "vertrauenswuerdig": "신뢰할 수 있는",
    "vision_gaia_technology": "비전Gaia기술",
    "von": "에서",
    "warnung": "경고",
    "wizard_address": "주소",
    "wizard_back": "뒤쪽에",
    "wizard_check1": "나는 내 씨앗을 안전하게 구했습니다.",
    "wizard_custom_domain": "자신의 도메인을 사용하세요",
    "wizard_desc1": "GaiaCOM은 서버 측에 개인 키를 저장하지 않습니다. Mnemonic Seed가 없으면 누구도 잃어버린 메시지를 복구할 수 없습니다.",
    "wizard_desc2": "귀하의 주소는 암호화된 봉투가 라우팅되는 페더레이션 노드를 결정합니다.",
    "wizard_fallback": "대체 노드",
    "wizard_finish": "설정 완료",
    "wizard_next": "더 나아가",
    "wizard_server_domain": "서버 노드 도메인",
    "wizard_step1": "1. 백업 시드",
    "wizard_step2": "2. 주소 및 서버",
    "wizard_title1": "복구 키 백업",
    "wizard_title2": "GaiaCOM 주소를 선택하세요",
    "write_message_placeholder": "보안 메시지를 작성하세요...",
    "you": "너",
    "zero_knowledge": "지식 제로",
    "zero_knowledge_encryption": "영지식 암호화",
    "Chat fuer alle geleert": "모든 참가자의 채팅이 비워졌습니다.",
    "Chat geleert": "로컬 받은편지함의 채팅이 삭제되었습니다.",
    "Nachricht fuer alle geloescht": "모든 참가자의 메시지가 삭제되었습니다.",
    "Nachricht geloescht": "채팅 메시지가 받은 편지함에서 로컬로 제거되었습니다.",
    "anpinnen": "핀",
    "chat_loeschen": "채팅 삭제",
    "confirm_delete_chat_desc": "정말로 채팅을 삭제하고 숨기시겠습니까?",
    "confirm_leave_group_desc": "정말로 이 그룹에서 탈퇴하시겠습니까?",
    "entpinnen": "고정 해제",
    "group_deleted": "그룹이 삭제되었습니다.",
    "group_left": "그룹에서 탈퇴했습니다.",
    "gruppe_loeschen": "그룹 삭제",
    "loeschen": "삭제",
    "no_active_chats": "활성 채팅이 없습니다. 채팅을 시작하려면 위에서 연락처를 검색하세요.",
    "pinned": "고정됨",
    "wizard_check_credentials": "나는 내 액세스 데이터를 안전하게 유지할 책임이 있습니다.",
    "wizard_check_is_beta": "나는 GaiaCom이 베타 소프트웨어라는 것을 알고 있습니다.",
    "wizard_check_no_illegal": "나는 GaiaCom을 불법적인 목적으로 사용하지 않겠습니다.",
    "wizard_check_no_uptime": "가용성이 보장되지 않는다는 점을 이해합니다.",
    "wizard_check_smtp_security": "나는 SMTP 메시지가 완전한 GaiaCom 보안을 제공하지 않는다는 것을 이해합니다.",
    "wizard_check_terms_read": "베타 서비스 약관을 읽었습니다.",
    "wizard_step_terms": "이용약관",
    "wizard_terms_text": "GaiaCom 이용 약관 및 베타 테스트 계약(베타 단계)\n\n공급자: VisionGaiaTechnology(이하 “공급자”라 함)\n상태: 공개 베타 테스트 단계\n유효기간: 2026년 6월 21일부터\n\n⚠️ 사전에 가장 중요한 참고사항(자세히 읽어주세요)\nGaiaCom은 공개 베타 테스트 단계에 있습니다. 광범위한 보안 조치에도 불구하고 소프트웨어와 기본 인프라의 오류 방지, 지속적인 가용성 또는 절대적인 보안은 보장할 수 없습니다. 자신의 책임하에 사용하십시오. 사용자는 자신의 액세스 데이터(특히 GaiaVault의 키)를 안전하게 저장하고 해당 법률을 준수할 책임이 있습니다.\n\n1. 베타 테스트 단계의 주제 및 목적\n1.1. 제공 목적: GaiaCom은 PQC(포스트 퀀텀 암호화)를 기반으로 하는 새로운 이메일 및 채팅 서비스입니다. 베타 단계의 제공은 기술 테스트, 로드 시뮬레이션, 프로그램 오류(버그) 찾기 및 사용자 친화성 최적화만을 위한 것입니다.\n1.2. 베타 상태: 사용자는 제공되는 소프트웨어가 예비 버전(베타 소프트웨어)임을 알고 있습니다. 이는 아직 기술적으로 완전히 개발되지 않았으며 최종 상용 제품의 표준을 충족하지 못하며 오류, 데이터 손실, 전송 지연 또는 시스템 충돌을 일으킬 수 있습니다.\n1.3. 계속할 권리 없음: 공급자는 언제든지 서비스 전체 또는 일부를 중단하거나, 기능을 변경 또는 제한하거나, 이유를 밝히지 않고 일시적 또는 영구적으로 제거할 수 있는 권리가 있습니다.\n\n2. 보증의 가용성 및 부인\n2.1. 가용성 보장 없음: GaiaCom은 가용성이나 가동 시간에 대한 보장 없이 제공됩니다. 서비스를 중단 없이 사용할 권리는 없습니다.\n2.2. 보증 제외: 소프트웨어는 현재 상태(\"있는 그대로\")로 제공되며 가용성에 따라 달라질 수 있습니다. 법이 허용하는 한도 내에서 소프트웨어의 물질적, 법적 결함에 대한 보증 청구는 제외됩니다. 특히, 소프트웨어에 오류가 없거나, 악성 코드가 없거나, 특정 목적에 적합하다는 보장은 없습니다.\n\n3. 위험 관리 및 사용자의 의무\n3.1. 중요 데이터 저장 금지: 사용자는 비즈니스에 중요하고 중요하며 운영상 필요하거나 법적으로 특히 민감한 데이터(예: 환자 파일, 매우 민감한 금융 데이터 또는 공식적으로 규제되는 비밀)를 GaiaCom을 통해 독점적으로 저장하거나 전송하지 않을 것을 약속합니다. 예상치 못한 장애로 인해 부상, 재산 피해 또는 상당한 금전적 손실이 발생할 수 있는 인프라에는 이 서비스를 사용할 수 없습니다.\n3.2. 자체 책임 백업: 사용자는 장기적으로 필요한 GaiaCom을 통해 수신 또는 전송된 모든 데이터를 자신의 독립 시스템(백업 복사본)에 백업할 책임이 있습니다. 공급자는 서버에 있는 데이터의 영구 저장 또는 복원 가능성을 보장하지 않습니다.\n\n4. 암호화 기능 및 GaiaVault\n4.1. PQC(포스트 양자 암호화): GaiaCom은 미래 양자 컴퓨터의 공격을 견딜 수 있도록 설계된 최첨단 미래 지향적 암호화 프로세스를 구현합니다. 그러나 사용자는 이것이 역동적이고 새로운 과학 분야라는 것을 알고 있습니다. 현재의 과학기술 수준으로는 절대적이고 반박할 수 없는 보안을 보장할 수 없습니다. \"100% 보안\", \"해킹 불가\" 또는 \"군사적 보안\"과 같은 용어는 명시적으로 보장되지 않습니다.\n4.2. 복구 보장 없음(GaiaVault): GaiaCom은 일관된 영지식 보안 개념을 사용합니다. 암호화 웨지 및 액세스 데이터는 전적으로 사용자가 제어할 수 있습니다(GaiaVault를 통해 보호됨).\n중요: 사용자가 비밀번호, 패스프레이즈, 개인 키 또는 복구 시드를 분실한 경우 공급자는 이 데이터를 재구성하거나 재설정할 수 있는 기술적 능력이 없습니다. 이러한 액세스 데이터가 손실되면 필연적으로 사용자 계정 및 해당 계정에 암호화된 모든 데이터에 대한 액세스가 영구적으로 손실됩니다.\n4.3. 아직 완전히 감사되지 않음: 소프트웨어는 지속적으로 내부 보안 검사를 받지만, 베타 단계가 진행되는 시점에는 아직 독립 테스트 기관의 최종적이고 포괄적인 외부 보안 감사를 받지 않았습니다.\n\n5. 인터페이스, 레거시 프로토콜 및 연합\n5.1. SMTP 브리지 참고: GaiaCom은 기존 이메일 프로토콜(예: SMTP)을 통해 통신하는 기능을 제공합니다. 사용자는 기본 GaiaCom 보안 영역을 벗어나는 메시지(예: 기존 @gmail.com 또는 @gmx.de 주소로 전송되는 경우)가 암호화되지 않은 서버나 타사 서버를 통해 전송된다는 것을 알고 있습니다. GaiaCom의 엔드투엔드 보안 보장은 발신 또는 외부 수신 레거시 메시지에 대해 제한된 범위에만 적용되거나 전혀 적용되지 않습니다.\n5.2. 연합 참고 사항: GaiaCom이 연합 네트워크에서 작동하는 경우 메시지와 데이터는 제3자 서버를 통해 전달될 수 있습니다. 메시지 내용은 종단 간 암호화로 보호되지만 메타데이터(예: 전송 시간, 관련 서버의 IP 주소, 수신자 주소)는 이러한 페더레이션 서버의 운영자에게 기술적으로 표시될 수 있습니다. 공급자는 페더레이션 네트워크에 있는 제3자 서버 운영자의 데이터 보호 관행에 영향을 미치지 않습니다.\n\n6. 허용되는 사용 및 금지된 활동\n사용자는 서비스를 부적절하거나 불법적인 목적으로 사용하지 않을 것을 약속합니다. 특히 다음은 금지됩니다.\n- 바이러스, 악성 코드, 피싱 콘텐츠 또는 기타 악성 소프트웨어를 배포, 전송 또는 호스팅하는 행위.\n- 서비스 거부 공격(DDoS) 또는 원치 않는 대량 메일 발송(스팸)을 수행하기 위해 서비스를 이용하는 행위.\n- 시스템을 악용하여 사기를 저지르는 행위.\n- 불법 콘텐츠, 특히 아동 성적 학대(CSAM) 묘사, 테러리스트 선전, 폭력 촉구 또는 기타 범죄 관련 콘텐츠의 배포 또는 교환.\n\n7. 악용사례 신고제도\n7.1. 욕설 신고: 사용자는 통합 욕설 시스템을 통해 욕설이나 불법 행위를 신고할 수 있습니다.\n7.2. 보고서 처리: 오용을 방지하기 위해 들어오는 보고서를 기술적으로 분석할 수 있습니다(개인 정보 보호 및 암호화 제한은 유지됨). 이로 인해 본 이용 약관을 위반한 것이 입증된 경우 사용자 계정이나 IP 주소가 일시적 또는 영구적으로 정지될 수 있습니다.\n\n8. 책임의 제한\n8.1. 책임 표준: 베타 소프트웨어는 무료로 제공됩니다. 따라서 기부 또는 대출에 대한 법적 규칙에 따라 제공자는 고의(의도적 손해)와 중과실에 대해서만 책임을 집니다.\n8.2. 데이터 손실에 대한 책임 배제: 데이터 손실에 대한 책임은 공급자의 고의 또는 중과실로 인해 손실이 발생하지 않고 사용자가 정기적인 백업(GaiaCom 외부)을 통해 피해를 완화할 의무를 이행한 경우를 제외하고는 제외됩니다.\n8.3. 법적 제한: 위의 책임 제한은 생명, 신체 또는 건강에 대한 상해 또는 제조물 책임법에 따른 책임에는 적용되지 않습니다.\n\n9. 오픈 소스\n특정 GaiaCom 구성 요소, 라이브러리 또는 클라이언트 애플리케이션은 오픈 소스 라이선스(예: GPL, MIT, Apache)에 따라 라이선스가 부여될 수 있습니다. 이러한 구성 요소의 각 라이센스 조건은 본 사용 조건의 영향을 받지 않으며 해당 소스 코드 저장소에서 볼 수 있습니다.\n\n10. 수출 통제 및 규정 준수\n사용자는 암호화 소프트웨어가 엄격한 수출 통제 및 법적 제한을 받을 수 있다는 것을 알고 있습니다. 사용자는 GaiaCom의 사용이 해당 거주 국가의 법률, 수입/수출 제한 또는 암호화 규정을 위반하지 않도록 할 책임이 있습니다.\n\n11. 데이터 보호 공지(베타용 단축 버전)\n11.1. 최소 데이터 수집: 베타 단계의 일부로 공급자는 기술 운영, 문제 해결 및 추가 개발에 절대적으로 필요한 데이터(예: 오류 진단을 위한 서버 로그 파일)만 수집합니다.\n11.2. 콘텐츠에 대한 통찰력 없음: 일관된 영지식 및 E2E 암호화 덕분에 공급자는 GaiaVault에 저장된 채팅, 이메일 또는 키 콘텐츠에 절대 액세스할 수 없습니다.\n11.3. 세부 데이터 보호 선언: 세부 데이터 보호 규정은 별도로 링크되어 있으며 등록하기 전에 사용자도 이를 고려해야 합니다.\n\n12. 최종 조항\n12.1. 준거법: 국제물품매매계약에 관한 UN 협약을 제외하고 독일연방공화국 법률이 적용됩니다.\n12.2. 변경될 수 있음: GaiaCom은 활발하게 개발 중이므로 공급자는 미래에 영향을 미치기 위해 언제든지 이러한 조건을 조정할 권리를 보유합니다. 현재 버전은 응용 프로그램에서 사용할 수 있습니다.",
    "wizard_terms_title": "GaiaCom 이용 약관 및 베타 테스트 계약(베타 단계)",
    "node_operator": "노드 운영자",
    "search_channels": "채널 검색...",
    "senior_reviewer": "수석 검토자",
    "trusted_reviewer": "신뢰할 수 있는 리뷰어",
    "active_frequencies": "활성 주파수",
    "connected_rooms": "연결된 공간",
    "dashboard": "계기반",
    "empty_chats": "사용 가능한 활성 채팅이 없습니다.",
    "empty_messages": "새 메시지가 없습니다.",
    "encrypted": "암호화됨",
    "gaiacom_uplink": "가이아콤 업링크",
    "install_app": "앱 설치",
    "install_app_desc": "빠른 시작 및 오프라인 모드용",
    "kommandozentrale_alpha": "ALPHA 명령 센터",
    "network_online": "네트워크: 온라인",
    "new_room": "새로운 공간",
    "no_frequencies_active": "활성화된 주파수가 없습니다. 커뮤니케이션을 시작하려면 새 방을 만드세요.",
    "no_id": "신분증 없음",
    "open_chats": "오픈채팅",
    "open_inbox": "받은편지함 열기",
    "primary_identity": "기본 ID",
    "recent_chats": "새로운 채팅",
    "recent_messages": "최신 뉴스",
    "session_encrypted": "암호화된 세션: {name}",
    "session_secure": "상태: 안전함",
    "system_verlassen": "출구 시스템",
    "write_message": "메시지 쓰기",
    "onboarding_step_profile": "프로필",
    "onboarding_step_security": "보안",
    "onboarding_step_backup": "백업",
    "onboarding_step_launch": "시작",
    "onboarding_loading_gaia_id": "Gaia-ID 로드 중",
    "onboarding_setup_kicker": "GaiaCom 초기 설정",
    "onboarding_profile_title": "GaiaCom을 당신만의 공간으로 만드세요.",
    "onboarding_profile_desc": "사용자 이름과 아바타는 로컬에서 제어되며 나중에 프로필에서 언제든지 변경할 수 있습니다.",
    "onboarding_security_title": "GaiaCom이 현재 보호하고 있는 것.",
    "onboarding_security_desc": "GaiaCom은 신원, 키, 메시지 및 네트워크 상태를 분리합니다. 여기서는 간략한 사용자 정보만 제공합니다.",
    "onboarding_backup_title": "백업은 진정한 비상구입니다.",
    "onboarding_backup_desc": "복구 데이터가 없으면 누구도 귀하의 신원을 살려낼 수 없습니다. 이것이 바로 진정한 종단간 보안의 목적입니다.",
    "onboarding_launch_title": "준비 완료. 먼저 무엇을 하고 싶으신가요?",
    "onboarding_launch_desc": "바로 시작할 수도 있고, 튜토리얼을 종료한 뒤 대시보드에서 계속 진행할 수도 있습니다.",
    "onboarding_display_name": "표시 이름",
    "onboarding_display_name_placeholder": "GaiaCom에 표시할 이름을 입력하세요.",
    "onboarding_select_avatar": "아바타 선택",
    "onboarding_sec_identity_title": "신원 보호",
    "onboarding_sec_identity_desc": "귀하의 Gaia-ID는 네트워크 앵커입니다. 연락처는 키 교체를 감지할 수 있습니다.",
    "onboarding_sec_messages_title": "메시지 보호",
    "onboarding_sec_messages_desc": "콘텐츠는 로컬에서 복호화됩니다. 수정된 메시지는 새로운 서명을 수신합니다.",
    "onboarding_sec_network_title": "네트워크",
    "onboarding_sec_network_desc": "보안 센터 및 불만 신고 센터는 전역 백도어 없이 위험을 가시화합니다.",
    "onboarding_sec_transparency_title": "투명성",
    "onboarding_sec_transparency_desc": "경고를 추적할 수 있도록 보안 관련 이벤트를 로그에 기록합니다.",
    "onboarding_backup_notice_title": "일반 사용자를 위한 중요 사항",
    "onboarding_backup_notice_desc": "복구 데이터를 이 기기와 다른 곳에 분리해서 저장하세요. 비밀번호와 백업을 분실하면 GaiaCom은 복구 불가능하게 잠깁니다.",
    "onboarding_backup_consent": "백업이 복구 및 기기 변경에 매우 중요하다는 것을 인지하고 있습니다.",
    "onboarding_inbox_title": "받은 편지함",
    "onboarding_inbox_desc": "메일을 읽고 첫 메시지를 작성합니다.",
    "onboarding_contacts_title": "연락처",
    "onboarding_contacts_desc": "첫 연락처를 확인하거나 대화를 시작합니다.",
    "onboarding_channels_title": "채널",
    "onboarding_channels_desc": "공개 채널을 발견합니다.",
    "onboarding_security_title_card": "보안 센터",
    "onboarding_security_desc_card": "GaiaShield 보안 상태를 확인합니다.",
    "onboarding_later": "나중에",
    "onboarding_back": "뒤로",
    "onboarding_continue": "계속",
    "onboarding_complete_setup": "설정 완료",
    "auth_legal_consent": "개인정보 보호정책 및 이용약관을 읽었으며 이에 동의합니다.",
    "auth_show_terms": "이용약관 보기",
    "auth_recovery_mode": "복구 모드",
    "auth_recovery_import_title": "복구 파일 가져오기",
    "auth_recovery_import_desc": "비밀번호로 보호된 백업 파일에서 GaiaCom 키를 복원합니다. 복원 후 니모닉과 사용자 이름이 자동으로 입력됩니다.",
    "auth_recovery_file_pwd_placeholder": "복구 파일 비밀번호",
    "auth_recovery_local_pwd_placeholder": "새 로컬 잠금 해제 비밀번호(최소 12자)",
    "auth_recovery_importing": "가져오는 중...",
    "auth_recovery_decrypt": "복구 데이터 복호화",
    "auth_back_to_login": "로그인으로 돌아가기",
    "auth_terms_title": "GaiaCom 베타 이용약관",
    "auth_terms_close": "닫기",
    "auth_cookie_title": "GaiaCOM은 주권을 유지합니다.",
    "auth_cookie_desc": "언어, 세션 및 보안을 위해 기술적으로 필수적인 로컬 저장소만 사용합니다. 추적, 광고 쿠키 또는 제3자 프로필은 사용하지 않습니다.",
    "auth_cookie_accept": "확인",
    "sc_explainer_title": "여기서 실제로 보호되는 것은 무엇인가요?",
    "sc_explainer_desc": "GaiaShield는 계정, 메시지, 그리고 네트워크 사이의 보호막입니다. 콘텐츠 자체를 검열하지 않고 변조, 재전송 공격, 무단 액세스, 의심스러운 로그인 패턴, 불안정한 게이트웨이 전환과 같은 기술적 위험을 방지합니다.",
    "sc_explainer_identity_desc": "로그인 이상 징후, 세션 위험 및 타인 신원에 대한 접근을 검사합니다.",
    "sc_explainer_messages_desc": "재전송 패턴, 변조된 봉투 및 무결성 기능 부족을 감지합니다.",
    "sc_explainer_network_desc": "신뢰성이 잘못 표시되기 전에 연동, 속도 제한 및 SMTP 위험을 플래그 지정합니다.",
    "sc_open_security_warnings": "미처리 보안 경고",
    "sc_opt_all": "전체",
    "sc_opt_low": "낮음",
    "sc_opt_medium": "보통",
    "sc_opt_high": "높음",
    "sc_opt_critical": "심각",
    "sc_opt_failed_login": "로그인 실패",
    "sc_opt_auth_attack": "인증 공격",
    "sc_opt_rate_limit": "요청 속도 제한",
    "sc_opt_policy_violation": "보안 정책 안내",
    "sc_opt_message_replay": "메시지 재전송 공격",
    "sc_node_security_data_unavailable": "노드 보안 데이터를 사용할 수 없습니다",
    "sc_total_events": "총 이벤트 수",
    "sc_login_attacks": "로그인 공격 횟수",
    "sc_rate_limits_active": "활성 속도 제한",
    "sc_smtp_shield_hits": "SMTP Shield 탐지 수",
    "sc_top_event_categories": "주요 이벤트 범주",
    "sc_no_entries": "기록이 없습니다.",
    "sc_node_audit_log": "노드 감사 로그(최근 이벤트)",
    "sc_no_node_events": "노드 이벤트가 없습니다.",
    "archiv": "아카이브",
    "entwuerfe": "임시 보관함",
    "markiert": "별표 표시됨",
    "wichtig": "중요",
    "snoozed": "스누즈됨",
    "papierkorb": "휴지통",
    "spam": "스팸",
    "cancel": "취소",
    "error": "오류",
    "success": "성공",
    "kopieren": "복사",
    "block_contact": "연락처 차단",
    "unblock_contact": "연락처 차단 해제",
    "report_contact": "연락처 신고",
    "check_fingerprint": "지문 확인",
    "export_encrypted": "내보내기 (암호화됨)",
    "export_gaiaproof": "내보내기 (GaiaProof)",
    "export_password_prompt": "채팅 내보내기를 암호화할 비밀번호를 입력하세요:",
    "export_success": "채팅이 성공적으로 암호화되어 내보내졌습니다.",
    "export_failed": "내보내기 실패: ",
    "gaiaproof_export_success": "GaiaProof 패키지가 성공적으로 내보내졌습니다.",
    "gaiaproof_export_failed": "GaiaProof 내보내기 실패: ",
    "export_gaiaproof_confirm": "모든 서명과 서버 전송 영수증이 포함된 GaiaProof 패키지를 다운로드하시겠습니까? 시간이 걸릴 수 있습니다.",
    "group_settings_is_private": "비공개 방 (공개 검색 불가, 가입 요청을 통해서만 가입 가능)",
    "group_settings_read_only": "읽기 전용 모드 (소유자와 관리자만 메시지를 보낼 수 있음)",
    "group_settings_slow_mode": "슬로우 모드 (전송 재사용 대기시간)",
    "gsn_title": "GSN 소셜 피드",
    "gsn_node_feed": "노드 피드",
    "gsn_following_feed": "팔로잉",
    "gsn_feed_empty": "게시물을 찾을 수 없습니다.",
    "gsn_composer_placeholder": "연합의 새로운 소식은 무엇인가요?",
    "gsn_post_btn": "공유",
    "gsn_profile": "사용자 프로필",
    "gsn_followers": "팔로워",
    "gsn_following": "팔로잉",
    "gsn_bio": "설명 / 소개:",
    "gsn_bio_label": "설명 / 소개",
    "gsn_display_name": "표시 이름",
    "gsn_edit_profile": "프로필 편집",
    "gsn_save_profile": "저장",
    "gsn_add_image": "이미지 추가 (암호화됨)",
    "gsn_add_emoji": "이모티콘 삽입",
    "gsn_avatar_emoji": "아바타 (이모티콘)",
    "gsn_follow": "팔로우",
    "gsn_unfollow": "언팔로우",
    "gsn_repost": "공유 / 리포스트",
    "gsn_post_created": "게시물이 성공적으로 공유되었습니다.",
    "gsn_image_uploaded": "이미지가 암호화되어 업로드되었습니다.",
    "gsn_upload_failed": "이미지 업로드 실패: ",
    "gsn_comment_placeholder": "댓글을 입력하세요...",
    "gsn_delete_confirm_title": "게시물을 삭제하시겠습니까?",
    "gsn_delete_confirm_desc": "이 게시물을 영구적으로 삭제하시겠습니까?",
    "gsn_delete_comment_confirm_title": "댓글을 삭제하시겠습니까?",
    "gsn_delete_comment_confirm_desc": "이 댓글을 영구적으로 삭제하시겠습니까?",
    "gsn_report": "신고",
    "gsn_report_title": "위반 신고",
    "gsn_report_category": "카테고리",
    "gsn_report_spam": "스팸 / 광고",
    "gsn_report_harassment": "괴롭힘 / 혐오 발언",
    "gsn_report_abuse": "남용",
    "gsn_report_illegal": "불법 콘텐츠",
    "gsn_report_severity": "심각도",
    "gsn_report_low": "낮음",
    "gsn_report_medium": "보통",
    "gsn_report_high": "높음",
    "gsn_report_comment": "추가 의견",
    "gsn_report_submit": "신고",
    "gsn_report_submitted": "신고가 거버넌스에 제출되었습니다.",
    "gsn_report_post": "게시물 신고",
    "report_group": "그룹 신고",
    "report_group_reason_prompt": "신고 사유를 입력하세요 (선택 사항):",
    "report_reason_prompt": "신고 사유를 입력하세요 (선택 사항):",
    "report_failed": "신고 실패: ",
    "report_success": "연락처가 성공적으로 신고되었습니다.",
    "room_read_only_placeholder": "소유자와 관리자만 작성할 수 있습니다",
    "read_only_active": "읽기 전용 모드",
    "slow_mode_active": "슬로우 모드 활성화됨",
    "kommandozentrale": "커맨드 센터",
    "kontakt_blockiert": "연락처 차단됨",
    "kontakt_freigegeben": "연락처 차단 해제됨",
    "mailbox_settings_title": "메일함 설정",
    "mailbox_settings_desc": "서명, 언어, 메일 필터 관리.",
    "mic_access_denied": "마이크 접근이 거부되었습니다: ",
    "no_frequencies_active_desc": "대화를 시작하려면 새 방을 만드세요.",
    "key_changed_warning_title": "보안 고지:",
    "key_changed_warning_desc": "이 발신자의 신원 키가 업데이트되었거나 이전에 알려진 키와 다릅니다. 다른 보안 채널을 통해 지문을 확인하세요.",
    "sc_col_category": "카테고리",
    "search_members": "멤버 검색...",
    "tab_general": "일반",
    "tab_members": "멤버",
    "tab_requests": "요청",
    "tab_invites": "초대",
    "tab_logs": "로그",
    "auth_why_gaiacom": "왜 GaiaCOM인가요?",
    "auth_why_gaiacom_desc": "비밀 통신을 위한 안전하고 분산된 대안.",
    "auth_self_managed_id": "자체 관리형 ID",
    "auth_self_managed_id_desc": "이메일 주소나 전화번호 제공 없이 안전한 암호화 신원을 즉시 생성합니다.",
    "auth_gaiadrop_secure_exchange": "계정 없이 안전한 교환",
    "auth_gaiadrop_benefit_e2ee": "종단간 암호화됨",
    "auth_gaiadrop_benefit_no_login": "로그인 불필요",
    "auth_gaiadrop_benefit_inbox": "수신자의 수신함으로 직접 전송",
    "auth_terms_of_use": "이용 약관",
    "auth_terms_of_use_show": "이용 약관 표시",
    "auth_consent_privacy_terms": "개인정보 처리방침과 이용 약관을 읽었으며 이에 동의합니다.",
    "auth_recovery_import_file": "복구 파일 가져오기",
    "auth_recovery_password": "복구 파일 비밀번호",
    "auth_recovery_local_password": "새로운 로컬 잠금 해제 비밀번호 (최소 12자)",
    "auth_recovery_decrypting": "복구 데이터 복호화 중...",
    "auth_recovery_back": "로그인으로 돌아가기",
    "auth_cookie_sovereign": "GaiaCOM은 주권을 유지합니다.",
    "auth_cookie_sovereign_desc": "언어, 세션 및 보안을 위해 기술적으로 필요한 로컬 저장소 기능만 사용합니다. 추적 없음, 광고용 쿠키 없음, 타사 프로필 없음.",
    "auth_cookie_sovereign_accept": "확인",
    "unlock_keyboard_toggle": "⌨️ 키보드 사용",
    "unlock_keypad_toggle": "🔢 PIN 패드 사용",
    "unlock_status_denied": "접근 거부 / 재시도",
    "unlock_status_decrypting": "보관함 복호화 중...",
    "unlock_status_secured": "보관함 보안 적용 / 잠김",
    "auth_landing_nav_legal": "법적 고지",
    "auth_landing_nav_beta": "베타 테스트",
    "auth_landing_card1_title": "양자 내성 암호 (ML-KEM)",
    "auth_landing_card2_title": "100% 탈중앙화",
    "auth_landing_card3_title": "영지식 증명",
    "auth_landing_card4_title": "메타데이터 보호",
    "auth_landing_card5_title": "자가 관리형 ID",
    "auth_landing_hybrid_title": "현재의 암호학 기술로 미래의 위협에 대비합니다.",
    "auth_landing_hybrid_desc": "GaiaCom은 입증된 고전적 키 교환과 양자 내성 키 캡슐화를 결합합니다. 맹목적 선택이 아닌 다층 방어를 제공합니다.",
    "auth_landing_x25519_desc": "현재의 기기 및 안전한 세션을 위한 신속하고 입증된 타원곡선 키 교환.",
    "auth_landing_mlkem_desc": "사전 수집 후 사후 해독 시나리오에 대항하여 장기적인 기밀성을 보장하는 양자 내성 키 캡슐화.",
    "auth_landing_cycle_title": "서버는 아무것도 보지 못합니다. 네트워크는 오직 암호 노이즈만 전송합니다.",
    "auth_landing_step1_title": "로컬 암호화",
    "auth_landing_step1_desc": "메시지는 네트워크나 서버에 도달하기 전 송신자의 기기에서 먼저 암호화됩니다.",
    "auth_landing_step2_title": "Blob 형태로 전송",
    "auth_landing_step2_desc": "패킷은 연합 노드나 탈중앙화 저장소 레이어를 거치며 암호 노이즈 형태로 전달됩니다.",
    "auth_landing_step3_title": "연합 저장소",
    "auth_landing_step3_desc": "중앙 집중식 허니팟 메일박스가 존재하지 않습니다. 데이터는 분할, 연합 및 분산되어 완벽히 암호화됩니다.",
    "auth_landing_step4_title": "로컬 복호화",
    "auth_landing_step4_desc": "수신자의 개인 키만이 수신된 암호 노이즈를 다시 읽을 수 있는 내용으로 변환할 수 있습니다.",
    "auth_landing_trinity_title": "하나의 프로토콜 개념. 세 가지 인프라 레벨.",
    "auth_landing_enterprise_desc": "기업, 법률사무소, 중소기업, 산업 및 프라이빗 뱅킹용. 관리 권한 제어와 지원을 제공하는 독립된 통신망.",
    "auth_landing_enterprise_list1": "내부 주권 확보 및 사용자 관리",
    "auth_landing_enterprise_list2": "자체 호스팅 노드 또는 관리형 주권 클러스터 구축",
    "auth_landing_enterprise_list3": "SLA 보장, 기술 지원 및 프리미엄 모듈 제공",
    "auth_landing_network_desc": "디지털 프라이버시를 위한 개방형 네트워크. 데이터 상거래가 없으며, 오직 자유롭고 암호화된 통신을 위한 인프라입니다.",
    "auth_landing_network_list1": "오픈소스 클라이언트 앱",
    "auth_landing_network_list2": "연합 노드 환경",
    "auth_landing_network_list3": "중앙 복호화 키 미보유",
    "auth_landing_defend_desc": "정부 기관, 핵심 인프라 및 격리된 통신 환경을 위해 고도로 세분화된 맞춤형 보안 인프라.",
    "auth_landing_defend_list1": "인터넷과 완벽히 격리된 폐쇄망(air-gapped) 배포",
    "auth_landing_defend_list2": "화이트라벨 솔루션 제공 및 소스코드 감사 진행",
    "auth_landing_defend_list3": "국가 디지털 주권 확보",
    "auth_landing_gov_title": "오픈 프로토콜. 상업적 실행. 명확한 법적 분리.",
    "auth_landing_gov_desc": "GaiaCom은 오픈 프로토콜, 오픈 클라이언트 및 상용 프리미엄 인프라를 분리합니다. 신뢰는 투명성에서 나오며, 수익은 기업 운영, 지원, 통합 및 전용 모듈에서 발생합니다.",
    "auth_landing_price1_desc": "앱 스토어 배포 시 봇 방지를 위한 단회성 비용 청구.",
    "auth_landing_price2_desc": "직접 컴파일하여 사용하는 사용자를 위한 무료 오픈소스 제공.",
    "auth_landing_price3_desc": "중소기업, 법률사무소 및 보안에 민감한 팀을 위한 패키지.",
    "auth_landing_price4_desc": "대기업, 고가용성 클러스터, LDAP 연동 및 관리자 루트 권한 필요 시.",
    "auth_landing_license1_desc": "사용자, 포크 프로젝트 및 커뮤니티 감사를 위한 최상의 소스코드 투명성 보장.",
    "auth_landing_license2_desc": "프로토콜의 상업적 폐쇄를 방지하는 카피레프트(copyleft) 저작권 보호.",
    "auth_landing_license3_desc": "LDAP 연동, 루트 권한, 감사 기능, SLA 및 전용 비즈니스 로직 제공.",
    "auth_landing_final_title": "제로 트러스트 모델에 기반한 통신 방식.",
    "auth_landing_final_desc": "GaiaCom은 단순히 이메일을 대체하는 것에 그치지 않습니다. 양자 내성 마이그레이션이 진행 중인 현시점에 기밀 통신이 왜 아직도 읽기 쉬운 서버와 40년 전의 낡은 가정에 기반하고 있는지 의문을 제기합니다.",
    "auth_landing_final_note": "참고: 이 페이지는 아키텍처 구상 및 제품 로드맵을 설명합니다. 실제 적용 전에 구체적인 구현과 감사를 통해 보안성을 검증해야 합니다."




  };

export default ko;